import { render } from "./brand-area.vue?vue&type=template&id=1cf3cf9c&scoped=true"
import script from "./brand-area.vue?vue&type=script&lang=js"
export * from "./brand-area.vue?vue&type=script&lang=js"

import "./brand-area.vue?vue&type=style&index=0&id=1cf3cf9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf3cf9c"]])

export default __exports__